export default "__VITE_ASSET__O2JRr1w9__"